import(/* webpackMode: "eager" */ "/codebuild/output/src3110158394/src/autofoc.us/src/app/legal/page.js");
